module.exports = __webpack_public_path__ + "img/ntsf.8f8373f0.jpeg";